import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, User, Phone, ArrowRight } from 'lucide-react';
import Header from './components/Header25';
import Footer from './components/Footer25';

const Signup25 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', email: '', phone: '', password: '', confirmPassword: '',
    });

    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template25/login');
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px 14px 48px',
        border: '1px solid #DEE2E6', background: '#FFFFFF',
        fontSize: 14, outline: 'none', color: '#111111',
        fontFamily: 'IBM Plex Sans, sans-serif',
        borderRadius: 0, transition: 'border-color 0.2s'
    };

    const labelStyle = {
        display: 'block', fontSize: 12, fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: 8, fontFamily: 'Space Grotesk, sans-serif'
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-signup * { box-sizing: border-box; }
                .sahaj-signup { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-signup-heading { font-family: 'Space Grotesk', sans-serif; }
                .sahaj-signup input:focus { border-color: #0D7C66 !important; }
            `}</style>
            <div className="sahaj-signup" style={{ minHeight: '100vh' }}>
                <Header />

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: 'calc(100vh - 80px)', marginTop: 80 }}>
                    {/* Left - Image */}
                    <div style={{
                        background: '#111111', position: 'relative', overflow: 'hidden',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <img
                            src="https://images.pexels.com/photos/8839887/pexels-photo-8839887.jpeg?auto=compress&cs=tinysrgb&w=1200"
                            alt="Fashion"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }}
                        />
                        <div style={{ position: 'absolute', bottom: 60, left: 60, right: 60 }}>
                            <h2 className="sahaj-signup-heading" style={{
                                fontSize: 48, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.1,
                                letterSpacing: '-1px', margin: '0 0 16px'
                            }}>
                                BEGIN<br />YOUR<br />STYLE<br />JOURNEY
                            </h2>
                            <div style={{ width: 60, height: 3, background: '#0D7C66' }} />
                        </div>
                    </div>

                    {/* Right - Form */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px' }}>
                        <div style={{ width: '100%', maxWidth: 420 }}>
                            <h1 className="sahaj-signup-heading" style={{
                                fontSize: 40, fontWeight: 700, margin: '0 0 8px', letterSpacing: '-1px'
                            }}>
                                CREATE ACCOUNT
                            </h1>
                            <p style={{ fontSize: 15, color: '#6C757D', marginBottom: 40 }}>
                                Join us and discover contemporary Indian fashion
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
                                    <div>
                                        <label style={labelStyle}>First Name</label>
                                        <div style={{ position: 'relative' }}>
                                            <User size={18} color="#6C757D" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} />
                                            <input name="firstName" value={formData.firstName} onChange={handleInput} style={inputStyle} placeholder="First name" />
                                        </div>
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Last Name</label>
                                        <div style={{ position: 'relative' }}>
                                            <User size={18} color="#6C757D" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} />
                                            <input name="lastName" value={formData.lastName} onChange={handleInput} style={inputStyle} placeholder="Last name" />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label style={labelStyle}>Email</label>
                                    <div style={{ position: 'relative' }}>
                                        <Mail size={18} color="#6C757D" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} />
                                        <input name="email" type="email" value={formData.email} onChange={handleInput} style={inputStyle} placeholder="your@email.com" />
                                    </div>
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label style={labelStyle}>Phone</label>
                                    <div style={{ position: 'relative' }}>
                                        <Phone size={18} color="#6C757D" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} />
                                        <input name="phone" value={formData.phone} onChange={handleInput} style={inputStyle} placeholder="+91 XXXXX XXXXX" />
                                    </div>
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label style={labelStyle}>Password</label>
                                    <div style={{ position: 'relative' }}>
                                        <Lock size={18} color="#6C757D" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} />
                                        <input
                                            name="password" type={showPassword ? 'text' : 'password'}
                                            value={formData.password} onChange={handleInput}
                                            style={inputStyle} placeholder="Create password"
                                        />
                                        <button
                                            type="button" onClick={() => setShowPassword(!showPassword)}
                                            style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                                        >
                                            {showPassword ? <EyeOff size={18} color="#6C757D" /> : <Eye size={18} color="#6C757D" />}
                                        </button>
                                    </div>
                                </div>

                                <div style={{ marginBottom: 32 }}>
                                    <label style={labelStyle}>Confirm Password</label>
                                    <div style={{ position: 'relative' }}>
                                        <Lock size={18} color="#6C757D" style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)' }} />
                                        <input
                                            name="confirmPassword" type="password"
                                            value={formData.confirmPassword} onChange={handleInput}
                                            style={inputStyle} placeholder="Confirm password"
                                        />
                                    </div>
                                </div>

                                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, marginBottom: 32, cursor: 'pointer', lineHeight: 1.4, color: '#6C757D' }}>
                                    <input type="checkbox" style={{ accentColor: '#0D7C66', marginTop: 2 }} />
                                    I agree to the <span style={{ color: '#0D7C66', fontWeight: 500, cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); navigate('/template25/terms'); }}>Terms & Conditions</span> and <span style={{ color: '#0D7C66', fontWeight: 500, cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); navigate('/template25/privacy'); }}>Privacy Policy</span>
                                </label>

                                <button
                                    type="submit"
                                    style={{
                                        width: '100%', padding: '16px', background: '#0D7C66',
                                        color: '#FFFFFF', border: 'none', fontSize: 14, fontWeight: 700,
                                        cursor: 'pointer', display: 'flex', alignItems: 'center',
                                        justifyContent: 'center', gap: 10,
                                        textTransform: 'uppercase', letterSpacing: '2px',
                                        fontFamily: 'Space Grotesk, sans-serif',
                                        transition: 'background 0.2s'
                                    }}
                                    onMouseEnter={e => e.target.style.background = '#0A9B7F'}
                                    onMouseLeave={e => e.target.style.background = '#0D7C66'}
                                >
                                    Create Account
                                    <ArrowRight size={18} />
                                </button>
                            </form>

                            <div style={{ textAlign: 'center', marginTop: 32 }}>
                                <span style={{ fontSize: 14, color: '#6C757D' }}>
                                    Already have an account?{' '}
                                    <span onClick={() => navigate('/template25/login')} style={{ color: '#0D7C66', fontWeight: 600, cursor: 'pointer' }}>
                                        Sign In
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Signup25;
